module.exports = "<wow-product-save-to-list-new\r\n    ng-if=\"::$ctrl.settings.shelfProductTile.showSaveToListAsLink\"\r\n    product=\"::$ctrl.product\"\r\n    show-link=\"::$ctrl.showLink\"\r\n    class-modifier=\"::$ctrl.classModifier\"\r\n    show-inline=\"$ctrl.showInline\">\r\n</wow-product-save-to-list-new>\r\n\r\n<wow-product-save-to-list-legacy\r\n    ng-if=\"::!$ctrl.settings.shelfProductTile.showSaveToListAsLink\"\r\n    product=\"::$ctrl.product\">\r\n</wow-product-save-to-list-legacy>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/shop/productsavetolist/product-save-to-list.component.html
// module id = 259
// module chunks = 0 2